<template>
    <div class="c-a-checkbox" :class="{'c-a-checkbox--invalid' : invalid}">
        <input
            class="c-a-checkbox__input"
            type="checkbox"
            :name="`checkbox-${id}`"
            :id="`checkbox-${id}`"
            :checked="value"
            v-on:change="updated"
        >
        <label class="c-a-checkbox__label" :for="`checkbox-${id}`">
            <span class="c-a-checkbox__box">
                <icon :icon="'check'" />
            </span>
            <span class="c-a-checkbox__text" v-html="labelActual"></span>
        </label>
    </div>
</template>

<script>
    import Icon from '../AtomIcon.vue';

    export default {
        props: [
            'id',
            'label',
            'invalid',
            'required',
            'value'
        ],
        components: {
            Icon
        },
        computed: {
            labelActual: function() {
                return this.required ? `${this.label} *` : this.label;
            }
        },
        methods:{
            updated(event){
                this.$emit('input', event.target.checked);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/form/AtomCheckbox.vue